import { render, staticRenderFns } from "./UpdateCustomerInfo.vue?vue&type=template&id=064475bf&scoped=true"
import script from "./UpdateCustomerInfo.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerInfo.vue?vue&type=style&index=0&id=064475bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064475bf",
  null
  
)

export default component.exports